module.exports = __webpack_public_path__ + "static/media/profile-user (2)1.17a7ff40.png";